import { useDispatch } from 'react-redux';
import { Dispatch } from 'react';

import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { removeNoticeAction } from 'CorePackage/NotificationModule/actions/NoticeActions';

import styles from './CheckLists.module.scss';

interface ICheckListQuestionDeleteNoticeContent {
  name: string;
  id: string;
  onUndo: () => void;
}

export const CheckListQuestionDeleteNoticeContent = ({ name, id, onUndo }: ICheckListQuestionDeleteNoticeContent) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  function onClick() {
    dispatch(removeNoticeAction(id));
    onUndo();
  }

  return (
    <>
      Контрольный вопрос{name ? ` "${name}"` : ''} был удален.
      <button className={styles.QuestionDeleteUndoButton} type="button" onClick={onClick}>
        Отменить
      </button>
    </>
  );
};
